import BaseMarker from "./base_marker";

export default class CircleMarker extends BaseMarker {
  static anchor() {
    return "center";
  }

  static iconStyle(icon) {
    return {
      "width": "14px",
      "position": "absolute",
      "left": `${this.iconAlignmentValue(icon)}px`,
      "top": "13px",
    };
  }

  // Unfortunate compromise to have Maki markers align properly
  // in a circle marker. Additional values to be added as seen.
  //
  static iconAlignmentValue(icon) {
    switch(icon) {
    case 'toilets':
      return 13;
    default:
      return 14;
    }
  }

  static iconSvgAttributes() {
    return { "fill": "white" };
  }

  static markerStyle() {
    return { "width": "41px" };
  }

  static markerSvgAttributes() {
    return {
      "fill": "#8a6bee",
      "stroke": "#b8a6f4",
      "stroke-width": 5,
      "stroke-opacity": 1
    };
  }

  static markerType() {
    return "circle";
  }

  static dimensions() {
    return {
      "width": 40,
      "height": 40
    };
  }

  static popupOffsets() {
    return {
      'top': [0, this.dimensions().height / 2],
      'top-left': [0, this.dimensions().height / 2],
      'top-right': [0, this.dimensions().height / 2],
      'bottom': [0, -this.dimensions().height / 2],
      'bottom-left': [0, -this.dimensions().height / 2],
      'bottom-right': [0, -this.dimensions().height / 2],
      'left': [this.dimensions().width / 2, 0],
      'right': [(this.dimensions().width / 2) * -1, 0]
    };
  }
}
